// https://www.pfizershop.se/iframe.js?category=1&subCategory=2&embedded=1
// NOTE: when you get a CORS error from the staging domain it's because it requires basic auth. The best way to solve it is to edit the vhosts file on the webserver removing basic auth temporarily.

var script  = document.getElementById('shopScript');
var wrapper = script.parentNode;
var url = script.getAttribute('src').split('?').pop();
var urlParams = new URLSearchParams(url);
var category = urlParams.get('subCategory');
var parent_category = urlParams.get('category');
var product_id = urlParams.get('pid');
var cart_id = urlParams.get('cid');
var active_view = urlParams.get('activeView');
var parent_domain = urlParams.get('parent_domain');
var useDomain = 'https://'+(new URL(script.getAttribute('src'))).hostname;

if (urlParams.get('setEnv')) {
    switch(urlParams.get('setEnv')) {
        case 'local':
            useDomain = 'https://pfizershop.local.com';
            break;
        case 'stage':
        case 'staging':
            useDomain = 'https://pfizershop-new.c5391.cloudnet.cloud';
            break;
        case 'prod':
        case 'production':
            useDomain = 'https://www.pfizershop.se';
            break;
    }
}

if (new URLSearchParams(document.currentScript.src).has('embedded')) {
    var vueApp = document.createElement('div');
    vueApp.id = 'pfizerShopApp';
    wrapper.append(vueApp);

    var ss = document.createElement("link");
    ss.type = "text/css";
    ss.rel = "stylesheet";
    ss.href = useDomain+"/css/scoped_app.css";
    document.getElementsByTagName("head")[0].appendChild(ss);

    var vueScript = document.createElement('script');
    vueScript.src = useDomain+'/js/embed.js?parent_category=' + parent_category + (category ? '&category=' + category : '') + (product_id ? '&pid=' + product_id : '') + (active_view ? '&activeView=' + active_view : '') + (cart_id ? '&cid=' + cart_id : '') + (parent_domain ? '&parent_domain=' + parent_domain : '');
    wrapper.append(vueScript);

} else {
    document.addEventListener('DOMContentLoaded', function (event) {
        function resizeIframe(height) {
            var shopIframe = document.getElementById('shopIframe');
            height = parseInt(height);

            if (height && shopIframe) {
                shopIframe.height = height;
            }
        }

        window.addEventListener('message', function (event) {
            var height = parseInt(event.data);
            resizeIframe(height);
        }, false);

        var iframe  = document.createElement('iframe');
        iframe.id = 'shopIframe';
        iframe.width = '100%';
        iframe.src = useDomain + '/shop?standalone=true&parent_category=' + parent_category + (category ? '&category=' + category : '') + (product_id ? '&pid=' + product_id : '') + (cart_id ? '&cid=' + cart_id : '') + (parent_domain ? '&parent_domain=' + parent_domain : '');
        iframe.frameBorder = 0;
        iframe.scrolling = 'no';

        wrapper.appendChild(iframe);
    });
}